import { Link } from "react-router-dom";
import ScrollReveal from "@/components/feature/ScrollReveal";
import AppStoreButtons from "@/components/feature/AppStoreButtons";
import { useModal } from "@/hooks/useModal";

const features = [
  "Patient Management",
  "Electronic Medical Records (EMR)",
  "Billing & Insurance",
  "Lab & Pharmacy Integration",
  "Analytics & Reporting",
];

const ahisFeedbackFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSeETVSBPO16xyK_48EwDz-Vg-1hlD0_K9pXKRDEjbAkJNN6lA/viewform?usp=publish-editor";

export default function AHISPreview() {
  const { openDemo } = useModal();
  return (
    <section className="w-full py-16 md:py-24 bg-gray-50 dark:bg-dark-card">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <ScrollReveal>
              <span className="inline-block px-3 py-1 rounded-full bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-brand-400 text-xs font-semibold uppercase tracking-wider mb-4">
                Our Product
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                Introducing AHIS - Our Flagship Healthcare Platform
              </h2>
              <p className="text-sm md:text-base text-gray-500 dark:text-gray-400 leading-relaxed mb-6">
                AHIS (African Health Information System) is a SaaS platform built by Presuni for modern hospitals. Born from real enterprise healthcare needs, it unifies patient records, billing, labs, and pharmacy in one secure system.
              </p>
            </ScrollReveal>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {features.map((f, i) => (
                <ScrollReveal key={f} delay={i % 2 === 0 ? 1 : 2}>
                  <div className="flex items-center gap-2.5">
                    <div className="w-5 h-5 rounded-full bg-brand-50 dark:bg-brand-500/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-xs text-brand-500" />
                    </div>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {f}
                    </span>
                  </div>
                </ScrollReveal>
              ))}
            </div>

            <ScrollReveal delay={1}>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/ahis"
                  className="px-6 py-3 rounded-full bg-brand-500 text-white text-sm font-semibold hover:bg-brand-600 transition-colors whitespace-nowrap text-center cursor-pointer"
                >
                  Explore AHIS
                </Link>
                <a
                  href={ahisFeedbackFormUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 rounded-full bg-brand-50 dark:bg-brand-500/10 border border-brand-200 dark:border-brand-500/30 text-brand-700 dark:text-brand-300 text-sm font-semibold hover:bg-brand-100 dark:hover:bg-brand-500/20 transition-colors whitespace-nowrap text-center"
                >
                  Share AHIS Feedback
                </a>
                <button
                  onClick={openDemo}
                  className="px-6 py-3 rounded-full bg-white dark:bg-dark-bg border border-gray-200 dark:border-dark-border text-gray-700 dark:text-gray-300 text-sm font-semibold hover:border-brand-300 dark:hover:border-brand-500/30 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Book Demo
                </button>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={2}>
              <AppStoreButtons className="mt-4" />
            </ScrollReveal>
          </div>

          <ScrollReveal className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://storage.readdy-site.link/project_files/47b2e0f1-f782-46fd-9795-faa524ec7a75/a559afac-450d-4ce3-aebd-85f487f65729_Presentation-cover-grid-4.png?v=fbda99f309d65fe9379063991bd0accd"
                alt="AHIS dashboard preview"
                className="w-full h-[280px] md:h-[400px] object-cover rounded-2xl"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" />
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
